module.exports = __webpack_public_path__ + "static/wheel-of-life-e8d4afd6c4801fe6b58fb14350ce9f1a.jpg";